module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "form-modal-header"
  }, [_c('h1', {
    class: _vm.type == '1' ? 'remove' : ''
  }, [_vm._v("\n          " + _vm._s(_vm.type == "1" ? "EXCLUSÃO DE VEÍCULO!" : "Atenção!") + "\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          " + _vm._s(_vm.type == "1" ?
    "Deseja excluir o veículo selecionado?" :
    "Confirme se você digitou os dados do veículo corretamente:") + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-modal-body"
  }, [_c('div', {
    staticClass: "form-modal-container"
  }, [_c('div', {
    staticClass: "form-placa-desc"
  }, [_c('label', {
    attrs: {
      "for": "form-placa-desc"
    }
  }, [_vm._v("Placa")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "form-placa-conf"
    }
  }, [_c('span', {
    attrs: {
      "id": "plate-span"
    }
  }, [_vm._v(_vm._s(_vm.plateExibe))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-marca-desc"
  }, [_c('h4', [_vm._v("\n              Marca "), _c('span', {
    attrs: {
      "id": "brand-name-modal"
    }
  }, [_vm._v(_vm._s(_vm.brand))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-model-desc"
  }, [_c('div', {
    staticClass: "model-text"
  }, [_c('h4', [_vm._v("\n              Modelo "), _c('span', {
    attrs: {
      "id": "model-name-modal"
    }
  }, [_vm._v(_vm._s(_vm.model))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-modal-footer"
  }, [_c('button', {
    class: _vm.type == '1' ? 'cancel' : '',
    attrs: {
      "id": "cancel"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('ClickHandlerCancel')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.type == "1" ? "Fechar" : "Cancelar") + "\n        ")]), _vm._v(" "), _c('button', {
    class: _vm.type == '1' ? 'remove' : '',
    attrs: {
      "id": "confirm"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('ClickHandlerContinue')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.type == "1" ? "Excluir" : "Continuar") + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-3b45c5eb!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Adhesion/form-modal/form-modal.vue
// module id = 2103
// module chunks = 1